import React from "react";

// Single map of semantic tones → CSS variant class
const TONE = {
  neutral: "sb--neutral",
  brand:   "sb--brand",
  success: "sb--success",
  warning: "sb--warning",
  danger:  "sb--danger",
  info:    "sb--info",
  violet:  "sb--violet",
  teal:    "sb--teal",
};

// Map common status strings → tone
const PRESETS = {
  // Subscription / state
  ACTIVE: "success", INACTIVE: "neutral", TRIAL: "info", TRIALING: "info",
  EXPIRED: "danger", CANCELED: "danger", CANCELLED: "danger", PENDING: "warning",
  PAID: "success", UNPAID: "warning", FAILED: "danger",

  // Plan tiers
  BASIC: "neutral", PRO: "brand", ENTERPRISE: "violet",

  // Movement types
  PURCHASE: "info", SALE: "success", ADJUSTMENT: "warning",
  TRANSFER: "violet", RETURN: "neutral",

  // Roles
  SYSTEM_ADMIN: "violet", TENANT_ADMIN: "brand",
  BRANCH_ADMIN: "info", STOCK_MANAGER: "teal",
  ACCOUNTANT: "warning", CASHIER: "neutral",
};

const StatusBadge = ({ children, tone, value, dot = false, className = "" }) => {
  const label = value || children;
  const resolvedTone = tone || PRESETS[String(label).toUpperCase()] || "neutral";
  const cls = `sb ${TONE[resolvedTone] || TONE.neutral} ${className}`.trim();
  return (
    <span className={cls}>
      {dot && <span className="sb__dot" />}
      {label}
    </span>
  );
};

export default StatusBadge;
